// Keep the route fallback small and correctly sized before the journey CSS loads.
export default function JourneyLoading() {
  return (
    <div
      role="status"
      aria-label="Loading page"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 160 }}
    >
      <span
        className="animate-spin"
        aria-hidden="true"
        style={{
          display: 'block',
          width: 24,
          height: 24,
          border: '2px solid #e1e8e2',
          borderTopColor: '#2b5c5a',
          borderRadius: '50%',
        }}
      />
    </div>
  );
}
